import React, { useState, useEffect, useRef } from 'react'
import qr_img from '../../assets/img/vending/qr.png'
import VendingModalKeyCode from '../Vending/VendingModalKeyCode'
import VendingStock from './VendingStock';
import { Modal } from 'react-bootstrap';
import scanQR from './img/scanqr.jpg'
import scanQR2 from './img/scanyourqr.gif'

import ErrorAlert from '../../components/Alerts/ErrorAlert';
import SuccessAlert from '../../components/Alerts/SuccessAlert';
import LoadingAlert from '../../components/Alerts/LoadingAlert';

//api
import { AuthFetchAPI } from '../../api/Auth';

function VendingModalOperator({ logo, showModalAuthOperator, setShowModalAuthOperator, humidity, temperature, setShowModalStock, showModalStock, setEventHandlerMenu, showModalKeyCode, setShowModalKeyCode, setStatusScreen, nameBusiness, setAtivityTimer }) {
    const [codeSesion, setCodeSesion] = useState({
        business_code: "0000",
        branchoffice_code: "0000",
        machine_code: "0000",
    });
    const inputRef = useRef(null);


    const authOperator = () => {

        let business = JSON.parse(localStorage.getItem('business_vending'));
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'));
        let machine = JSON.parse(localStorage.getItem('machine_vending'));

        if (business.code == codeSesion.business_code) {
            if (branchoffice.code == codeSesion.branchoffice_code) {
                if (machine.code == codeSesion.machine_code) {
                    setStatusScreen(true);
                    ErrorAlert("Operador autenticado", "Acceso permitido", "success");
                    setShowModalAuthOperator(false);
                    setEventHandlerMenu(1);
                    setShowModalStock(true);

                } else {
                    ErrorAlert("Acceso denegado", "Codigo de Máquina incorrecto", "error");
                    setShowModalAuthOperator(false);
                    document.getElementById("inputCodeQrOperator").value = ""

                }
            } else {
                ErrorAlert("Acceso denegado", "Codigo de sucursal incorrecto", "error");
                setShowModalAuthOperator(false);
                document.getElementById("inputCodeQrOperator").value = ""
            }
        } else {
            ErrorAlert("Acceso denegado", "Codigo de empresa incorrecto", "error");
            setShowModalAuthOperator(false);
            document.getElementById("inputCodeQrOperator").value = ""
        }
        setShowModalKeyCode(false)
        setCodeSesion({ business_code: "0000", branchoffice_code: "0000", machine_code: "0000", });

    }


    const handleChange = (e) => {
        if (e.key == "Enter") {
            LoadingAlert()
            let inputValue = e.target.value.toUpperCase();
            let arrayCodeString = inputValue.split("X");
            console.log(arrayCodeString);

            codeSesion.business_code = parseInt(arrayCodeString[3])
            codeSesion.branchoffice_code = parseInt(arrayCodeString[2])
            codeSesion.machine_code = parseInt(arrayCodeString[1])
            setCodeSesion(codeSesion)
            authOperator()
        }

    }

    function actualizar() {
        window.location.reload();
    }

    return (
        <>
            <div
                //onClick={() => (setShowModalStock(true))} 
                onClick={() => (setShowModalAuthOperator(true), setAtivityTimer(2), setTimeout(() => { inputRef.current.focus() }, 3000))}>
                {/* <img src={logo} className='logo-main-vending m-1' /> */}

                <h2 className='fw-bold fs-1 text-dark'>{nameBusiness}</h2>
            </div>


            <Modal
                show={showModalAuthOperator}
                fullscreen
                centered
                onHide={() => setShowModalAuthOperator(false)}
            >
                <Modal.Body>
                    {/* <main className='vending' onClick={() => (inputRef.current.focus())} >
                        <span className='text-bg-dark fw-bold px-2 rounded-3' onClick={() => actualizar()}>Abastecimiento</span>
                        <div className="d-flex align-items-center flex-column bd-highlight">
                            <div className='vendindg-title  bd-highlight  pt-1'>
                                <h2 className='fw-bold mb-0 text-center text-title-help'>
                                    Validación de Usuario
                                </h2>
                            </div>
                            <div className='container  mt-2'>
                                <div className='vendindg-message  border-vending-primary  p-2 rounded-3'>
                                    <span className="mb-0  text-title-help text-primary">
                                        <i className="uil uil-info-circle"></i>  Por favor, coloque el código QR en el escáner de la máquina.
                                    </span>
                                </div>

                                <h2 className="fw-bold my-2 text-center button-sub-title ">O </h2>
                                <div className='bd-highlight d-block'>
                                    <div className="d-flex justify-content-center">
                                        <div className='vendindg-message border-vending-success   p-2 rounded-3'>
                                            <span className="mb-0  text-title-help text-success" >
                                                <i className="uil uil-info-circle me-1"></i>
                                                Ingresar de forma manual los códigos en la máquina.
                                            </span>
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center mt-5'>
                                        <button className='border-vending-success  px-5 display-5 fw-bold pulse'onClick={() => (setShowModalKeyCode(true))} >Ingresar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main> */}

                    <main
                        className="vmv-root"
                        onClick={() => (inputRef.current.focus())}
                    >

                        {/* Halo de fondo */}
                        <div className="vmv-halo" />

                        {/* ========== HEADER ========== */}
                        <header className="vmv-header">
                            <button
                                className="vmv-badge"
                                onClick={() => actualizar()}
                                title="Refrescar abastecimiento"
                            >
                                <i className="uil uil-refresh"></i>
                                <span>Abastecimiento</span>
                            </button>

                            <h1 className="vmv-title">
                                Validación de
                                <br />
                                <span>usuario</span>
                            </h1>

                            <p className="vmv-subtitle">Elige una opción para continuar</p>
                        </header>

                        {/* ========== CENTRO: dos opciones ========== */}
                        <main className="vmv-main">

                            {/* Opción 1: QR */}
                            <section className="vmv-option vmv-option-qr">
                                <div className="vmv-option-icon">
                                    <i className="uil uil-qrcode-scan"></i>
                                </div>
                                <div className="vmv-option-step">Opción 1</div>
                                <h2 className="vmv-option-title">Escanea tu QR</h2>
                                <p className="vmv-option-desc">
                                    Coloca el código QR en el escáner de la máquina
                                </p>
                                <div className="vmv-option-hint">
                                    <span className="vmv-option-hint-dot" />
                                    <span>Esperando escaneo</span>
                                </div>
                            </section>

                            {/* Separador visual "O" */}
                            <div className="vmv-divider">
                                <span className="vmv-divider-line" />
                                <span className="vmv-divider-text">O</span>
                                <span className="vmv-divider-line" />
                            </div>

                            {/* Opción 2: Ingresar código manual */}
                            <section className="vmv-option vmv-option-manual">
                                <div className="vmv-option-icon vmv-option-icon-green">
                                    <i className="uil uil-keyboard"></i>
                                </div>
                                <div className="vmv-option-step">Opción 2</div>
                                <h2 className="vmv-option-title">Ingresa manualmente</h2>
                                <p className="vmv-option-desc">
                                    Escribe tus códigos directamente en la máquina
                                </p>
                                <button
                                    className="vmv-option-btn"
                                    onClick={() => (setShowModalKeyCode(true))}
                                >
                                    <i className="uil uil-keyboard-show"></i>
                                    <span>Ingresar código</span>
                                </button>
                            </section>

                        </main>
                    </main>
                    <input id="inputCodeQrOperator" ref={inputRef} type='text' inputMode="none" onKeyPress={(e) => (handleChange(e))} className='vending-input-qr' autoFocus></input>


                </Modal.Body>

                <VendingModalKeyCode codeSesion={codeSesion} setCodeSesion={setCodeSesion} authMachineVending={authOperator} showModalKeyCode={showModalKeyCode} setShowModalKeyCode={setShowModalKeyCode}  ></VendingModalKeyCode>

                <footer className="vmp-footer">


                    <button
                        className="vmp-back border border-3"
                        onClick={() => (setShowModalAuthOperator(false), setAtivityTimer(3))}
                        title="Volver al menú"
                    >
                        <i className="uil uil-arrow-left"></i>
                        Volver
                    </button>

                </footer>


            </Modal>



        </>
    )
}

export default VendingModalOperator